<button mat-button [matMenuTriggerFor]="menu" class="nav-user-menu-name">
    <span class="nav-user-menu-name-name">{{userDisplayName}}</span>
    <span class="nav-user-menu-name-icon fal fa-angle-down"></span>
</button>
<mat-menu #menu yPosition="below" [overlapTrigger]="false">
    <button mat-menu-item [routerLink]="accountSettingsUrl">Account Settings</button>
    <button mat-menu-item (click)="signOut()">Sign Out</button>
</mat-menu>